import styles from './social-media-buttons.module.css';

const SocialMediaButtons = () => {
  return (
    <div className={styles.root}>
      <div
        className="uSocial-Share"
        data-type="share"
        data-options="round-rect,style4,default,absolute,horizontal,size24,eachCounter0,counter0,nomobile,mobile_position_right"
        data-social="vk,fb,twi,ok,mail,lj,lin,pinterest"
      ></div>
      <div
        id="yaShare"
        className="ya-share2"
        data-curtain
        data-color-scheme="whiteblack"
        data-services="messenger,telegram,viber,whatsapp,skype,tumblr,blogger"
      ></div>
      <div className="clearfix"></div>
    </div>
  );
};

export default SocialMediaButtons;
